export const getBorderClass = "border-b-4 border-t-4 border-white"

export const getHeroXPaddingClass = "px-6 sm:px-8 xl:px-10 2xl:px-4" // align header to all pages' hero component

export const getSectionPaddingClass = (p?: string) => {
  switch (p) {
    case "sm":
      return `px-8 py-8 sm:py-16 lg:px-16 lg:py-20`
    case "base":
      return `px-8 py-12 sm:py-16 ml:px-12 lg:px-16 lg:py-20`
    case "default":
      return `px-8 py-16 sm:py-20 md:py-28 ml:px-12 lg:px-16 lg:py-32`
    case "default-y":
      return `py-16 sm:py-20 md:py-28 lg:py-32`
    case "default-x":
      return `px-8 ml:px-16`
    default:
      return `px-8 py-16 sm:py-20 md:py-28 ml:px-12 lg:px-16 lg:py-32`
  }
}

export const getThemeClass = (theme: string, border?: string) => {
  switch (theme) {
    case "dark":
      return `from-6% via-30% to-80% text-white ${getGradientClass("v-d-to-l")} ${border ?? ""}`
    case "light":
      return `bg-lightgrey text-grey-85 ${border ?? getBorderClass}`
    case "dark-revert-purpleblue":
      return `${getGradientClass("purpleblue-v-l-to-d")} text-white ${border ?? ""}`
    case "dark-purpleblue":
      return `${getGradientClass("purpleblue-v-d-to-l")} text-white ${border ?? ""}`
    case "dark-revert":
      return `${getGradientClass("v-l-to-d")} text-white ${border ?? ""}`
  }
}

export const getTitleClass = (v: string) => {
  switch (v) {
    case "sm": // mostly for pretitle
      return "text-xl leading-6 md:text-2xl lg:text-[1.65rem]"
    case "base":
      return "text-2xl leading-8 md:text-3xl lg:text-4xl xl:text-[2.4rem] xl:leading-[1.2]"
    case "lg":
      return "text-3xl leading-8 lg:text-4xl xl:text-[2.5rem]"
    case "hero":
      return "text-[2rem] leading-8 md:text-[2.1rem] lg:text-[2.5rem]/9"
  }
}

export const getBodyClass = (v: string) => {
  switch (v) {
    case "xs":
      return "text-sm md:text-base xl:text-lg/6"
    case "sm":
      return "text-sm md:text-lg xl:text-xl"
    case "base":
      return "text-base md:text-xl xl:text-2xl"
    // return "text-base md:text-xl lg:text-2xl / text-base md:text-lg xl:text-xl 2xl:text-2xl";
    case "lg":
      return "text-[1.02rem] leading-6 sm:text-xl md:leading-relaxed lg:text-[1.7rem]"
  }
}

export const getGradientClass = (variant: string) => {
  switch (variant) {
    case "v-d-to-l":
      return "bg-gradient-to-b from-6% via-30% to-80% from-black via-gradient-blue2 to-gradient-blue1"
    case "v-l-to-d": // blue, three colours gradient by default
      return "bg-gradient-to-t from-black via-gradient-blue2 to-gradient-blue1"
    case "purpleblue-v-l-to-d":
      return "bg-gradient-to-b from-purpleblue to-black"
    case "purpleblue-v-d-to-l":
      return "bg-gradient-to-t from-purpleblue to-black"
    case "v-l-to-d-two-colours":
      return "bg-gradient-to-t from-gradient-blue2 to-gradient-blue1"
    case "h-l-to-d":
      return "bg-gradient-to-r from-gradient-blue3 via-gradient-blue4 to-gradient-blue5"
    case "h-d-to-l":
      return "bg-graident-to-l from-gradient-blue3 via-gradient-blue4 to-gradient-blue5"
  }
}
